<!-- 区域划分标题-->
<template>
    <div class="comp-divide-title comp">
        <div v-if="useStyle === 'bottom'" class="divide-bottom">
            <div class="tit" :style="titStyle">
                {{ title }}
            </div>
        </div>
        <div v-if="useStyle === 'left'" class="divide-left">
            <div class="left-line" :style="lineStyle"></div>
            <span class="tit" :style="titStyle">
                {{ title }}
            </span>
            <span class="tip">{{ tip }}</span>
            <slot name="btn"></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "DivideTitle",
    props: {
        useStyle: {
            type: String,
            default: "left" // bottom | left
        },
        title: {
            type: String,
            default: ""
        },
        tip: {
            type: String,
            default: ""
        },
        // 线段样式
        lineStyle: {
            type: Object,
            default: function () {
                return {
                    // "height": "20px"
                };
            }
        },
        titStyle: {
            // 自定义字体
            type: Object,
            default: function () {
                return {
                    "font-weight": "bold"
                    // "font-size": "18px" //字体大小
                };
            }
        }
    },
    data() {
        return {};
    }
};
</script>
<style lang="scss" scoped>
.comp-divide-title {
    .divide-bottom {
        font-size: 18px;
        line-height: 18px;
        height: 20px;
        padding: 10px 0;
        border-bottom: 1px solid #eaeaea;
    }
    .divide-left {
        display: flex;
        align-items: center;
        .left-line {
            width: 3.71px;
            height: 16px;
            margin-right: 6.29px;
            background-color: var(--color-primary);
        }
        .tit {
            color: #333;
            font-size: 18px;
        }
        .tip {
            font-size: 14px;
            margin-left: 8px;
            color: #999;
        }
    }
}
</style>
